/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstanceObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstanceObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000611", //RC 33000611 : Hromadné přiřazení instancí
                data: this.data,
                objectFields: (this.hromadnaOperaceObj.openFromInstance == true) ? ['ixs_ins_txt'] : ['ixs_usr_txt'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance",
                keys: this.keys,
                contentId: "hromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance "
            })
        }
    }

    export class HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstanceObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceReadDto> {
        typ_usr: number
        openFromInstance: boolean;

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
            if (this.openFromInstance == true) {
                form.addRow("jres:29929931").addField("gselectbox", Gordic.Prefabs.Select.ginsins(), {
                    name: "ixs_ins",
                    model: "model.ixs_ins=value.ixs_ins;model.ixs_ins_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: this.options.data.map((value) => ({ ixs_ins: value.ixs_ins })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            }
            if (this.typ_usr == 10) {
                var ixs_usr_arr = this.options.data.map((value) => value.ixs_usr)
                var initialValue = (ixs_usr_arr.length == 0) ? null : ixs_usr_arr[0] == null ? null : this.options.data.map((value) => ({ ixs_fun: value.ixs_usr }))
                form.addRow("jres:33000093").addField("gselectbox", Gordic.Prefabs.Select.ginsfunMini(), {
                    name: "ixs_usr",
                    model: "model.ixs_usr=value.ixs_fun;model.ixs_usr_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: initialValue,
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            } else {
                form.addRow("jres:33000113").addField("gselectbox", Gordic.Prefabs.Select.ginsusr(), {
                    name: "ixs_usr",
                    model: "model.ixs_usr=value.ixs_usr;model.ixs_usr_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    initialValue: this.options.data.map((value) => ({ ixs_usr: value.ixs_usr })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            }
            if (this.openFromInstance == false) {
                form.addRow("jres:29929931").addField("gselectbox", Gordic.Prefabs.Select.ginsins(), {
                    name: "ixs_ins",
                    model: "model.ixs_ins=value.ixs_ins;model.ixs_ins_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: this.options.data.map((value) => ({ ixs_ins: value.ixs_ins })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            }
            form.addRow("jres:29932056").addField("gselectbox", Gordic.Prefabs.Select.ginslok(), {
                name: "lic",
                dropdown: true,
                model: "model.lic=value.lic",
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
            }).addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                name: "aktivita",
                model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                initialValue: { aktivita: 100 },
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
            })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs_usr", "ixs_usr_txt"]), this.transformDataToArrayObject(formData, ["ixs_ins", "ixs_ins_txt"]));
            var resultArray: any = [];
            cartesianResult.forEach((item) => {
                var data = {
                    ixs_usr: item[0]["ixs_usr"],
                    ixs_usr_txt: item[0]["ixs_usr_txt"],
                    ixs_ins: item[1]["ixs_ins"],
                    ixs_ins_txt: item[1]["ixs_ins_txt"],
                    lic: formData['lic'],
                    aktivita: formData['aktivita']
                }
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            this.createAktivitaColumn(gridFormat);
            gridFormat.addTextColumn({
                caption: (this.typ_usr == 10) ? "jres:32131054" : "jres:29932054",
                name: "ixs_usr_txt",
            }).addTextColumn({
                caption: "jres:29929931",
                name: "ixs_ins_txt",
            }).addTextColumn({
                caption: "jres:29930142",
                name: "lic",
            })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    ixs_usr: item['ixs_usr'],
                    ixs_ins: item['ixs_ins'],
                    aktivita: item['aktivita'],
                    lic: item['lic'],
                    NewRecord: true
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred()
        }
    }
}